const params = new URLSearchParams(window.location.search);
const cpsId = params.get('cps');
const hasEmailAbandon = document.cookie.includes('emailAbandon=');

const encode = (doubleEncodedStr) => {
  return btoa(btoa(doubleEncodedStr));
};
const decode = (doubleEncodedStr) => {
  return atob(atob(doubleEncodedStr));
};

if (cpsId && !hasEmailAbandon) {
  getCustomerEmail(cpsId);
}

async function getCustomerEmail(cpsId) {
  try {
    const response = await fetch(`/apps/headless-controller/customer-profile?cps=${cpsId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const { email } = await response.json();
    const encodedEmail = encode(email);
    document.cookie = `emailAbandon=${encodedEmail}; path=/; max-age=${365 * 24 * 60 * 60}`;
  } catch (error) {
    console.error('Error calling proxy:', error);
  }
}
